import type { ComboboxRootProps } from '@base-ui/react';

import { Combobox as BaseCombobox } from '@base-ui/react';

type Props<Value, Multiple extends boolean | undefined = false, Item = Value> = ComboboxRootProps<Value, Multiple, Item>;

export const ComboboxRoot = <Value, Multiple extends boolean | undefined = false, Item = Value>({
  ...delegated
}: Props<Value, Multiple, Item>) => {
  return <BaseCombobox.Root {...delegated} autoHighlight={delegated.autoHighlight ?? true} />;
};
